@if (action.Components && !defaults.isReadonlyUser) {
  <table-fixed-header-search-collapse
    id-table="maintenance-control-plan-group-action-component-id"
    [header]="header"
    [data]="action.Components"
    [getValue]="getData"
    [selectable]="false"
    [rowNewTemplate]="newComponent"
    [rowExpandTemplate]="expandtemplate"
    [newService]="newService"
    [expanded]="expanded"
    (onExpand)="onExpand($event)"
    (onNewChild)="onNewChild($event)"
    (onDelete)="onDelete($event)"
    >
  </table-fixed-header-search-collapse>
}

@if (action.Components && defaults.isReadonlyUser) {
  <table-fixed-header-search-collapse
    id-table="maintenance-control-plan-group-action-component-id"
    [header]="header"
    [data]="action.Components"
    [getValue]="getData"
    [selectable]="false"
    [rowExpandTemplate]="expandtemplate"
    [expanded]="expanded"
    (onExpand)="onExpand($event)">
  </table-fixed-header-search-collapse>
}

<ng-template #expandtemplate let-index="index">
  @if (expanded[index]==true) {
    <maintenance-control-plan-group-action-component-error-list [newService]="newChildService" [component]="action.Components[index]"></maintenance-control-plan-group-action-component-error-list>
  }
</ng-template>

<ng-template #newComponent let-index="index">
  <maintenance-control-plan-group-action-component-new [header]="header" [list]="action.Components" [action]="action" [rowIndex]="index"></maintenance-control-plan-group-action-component-new>
</ng-template>